<template>
    <div id="interface">
        <div id="top-status">
            <div :style="objectMode!=2 ? 'opacity:0' : ''">Room mode active</div>
        </div>
        <div id="top-left-controls">
            <button :class="{'interface-button':true, 'selected': isMuted, 'error': !audioDeviceExists}" @click="toggleMuted()">
                <img v-if="!isMuted && audioDeviceExists" src="@/../static/icons/unmuted.svg" />
                <!--<svg v-if="!isMuted" width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="29.5" y="19" width="16" height="26" rx="8" fill="black"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M26.5 34C27.3284 34 28 34.6716 28 35.5V37C28 42.2467 32.2533 46.5 37.5 46.5C42.7467 46.5 47 42.2467 47 37V35.5C47 34.6716 47.6716 34 48.5 34V34C49.3284 34 50 34.6716 50 35.5V37C50 42.4761 46.4787 47.1297 41.5769 48.8201C40.4091 49.2228 39.5 50.2491 39.5 51.4843V52C39.5 53.1046 40.3954 54 41.5 54H42C42.8284 54 43.5 54.6716 43.5 55.5V55.5C43.5 56.3284 42.8284 57 42 57H33C32.1716 57 31.5 56.3284 31.5 55.5V55.5C31.5 54.6716 32.1716 54 33 54H33.5C34.6046 54 35.5 53.1046 35.5 52V51.4843C35.5 50.2491 34.5909 49.2228 33.4231 48.8201C28.5213 47.1297 25 42.4761 25 37V35.5C25 34.6716 25.6716 34 26.5 34V34Z" fill="black"/>
                    
                    <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="32" y="22" width="11" height="20">
                        <rect x="32" y="22" width="11" height="20" rx="5.5" fill="#FF4747"/>
                    </mask>
                    <g mask="url(#mask0)">
                        <rect x="32" y="28" width="11" height="14" fill="#82FF80"/>
                    </g>
                </svg>-->
                <img v-if="isMuted || !audioDeviceExists" src="@/../static/icons/muted.svg" />
            </button>
            <!--<button class="interface-button">
                <img src="@/../static/icons/unmuted_video.svg" />
            </button>-->
        </div>
        <div id="top-right-controls"  @blur="tr_tab=null">
            <div>
                <button :class="{'interface-button':true, 'selected': tr_tab=='share'}" @click="toggleTopRightPanel('share')">
                    <img src="@/../static/icons/share.svg" />
                </button>

                <!--<button :class="{'interface-button':true, 'selected': tr_tab=='settings'}" @click="toggleTopRightPanel('settings')">
                    <img src="@/../static/icons/gear.svg" />
                </button>-->
            </div>
            <div>
                <div v-if="tr_tab == 'share'" class="panel copy-panel">
                    <div class="input-container-share">
                        <div class="input-container">
                            <label class="label" for="shareURL">Link <span v-show="showCopiedMessage" style="color: #00DD66">({{ copiedMessage }})</span></label>
                            <input class="copy-message-link" type="text" :value="shareUrl" id="shareURL" readonly/>
                        </div>
                        <div @click="copyURL" class="copy-button copy-hover">
                            <div class="copy-icon-container">
                                <img class="copy-button-icon" src="@/../static/icons/link_big.svg">
                            </div>
                        </div>
                    </div>
                   <!-- <div v-show="showCopiedMessage" class="copy-message">
                        <div> {{ copiedMessage }} </div>
                      </div>-->

                </div>
                <!-- <div v-if="tr_tab == 'settings'" class="panel">
                    <div class="input-container">
                        placeholder settings pane
                    </div>
                </div> -->
            </div>
        </div>
        <div id="bottom-left-controls">
            <div>
                <div v-if="bl_tab == 'emoji'" class="object-panel panel">
                    <div>
                        <!--<button class="inner-button emoji-button" v-for="emoji_name in emotes" @click="sendEmoji(emoji_name)">
                            <img :src="`https://emoji.cozyroom.xyz/64/${emoji_name}.png`" :title="emoji_name.replace(/-/g, ' ')" />
                        </button>-->
                    </div>
                </div>
                <div v-if="bl_tab == 'object'" class="object-panel panel">
                    <div class="object-panel-header">
                        <button class="inner-button"></button>
                        <span class="object-panel-breadcrumb">
                            <u style="cursor:pointer" @click="objectPath=[]">Objects</u>
                            <span v-for="(item, index) in objectPath"> / <u style="cursor:pointer" @click="objectPath=objectPath.slice(index)">{{ item }}</u></span>
                        </span>
                    </div>
                    <div>
                        <div>
                            <div class="group-button-group" v-for="group in groupsAtPath">
                                <button class="inner-button object-button group-button" @click="appendPath(group.name)">
                                    <img v-for="object in group.objects.slice(0, 9)" :src="object.icon" style="max-width:16px; max-height: 16px; display: inline-block;" />
                                </button>
                                <div class="group-button-label" style="text-align: center;">{{ group.name }}</div>
                            </div>
                        </div>
                        <button class="inner-button object-button" v-for="object in objectsAtPath" @click="createObject(object)">
                            <img :src="object.icon" />
                        </button>
                    </div> 
                </div>

                <!-- MESSAGE PANEL -->
                <div v-if="bl_tab == 'message'" class="message-panel panel">
                    <form @submit.prevent="sendMessage" autocomplete="off">
                        <div class="input-container">
                            <!--<label class="label" for="roominput">Address</label>-->
                            <input type="text" v-model="message" placeholder="Message" @keydown="stopPropagation()" />
                        </div>
                    </form>
                </div>

                <!-- ROOM PANEL -->
                <div v-if="bl_tab == 'room'" class="room-panel panel">
                    <!--<div class="object-panel-header">
                        <button class="inner-button"></button>
                        <span class="object-panel-breadcrumb">
                            <u style="cursor:pointer">Rooms</u>
                            <!--<span v-for="(item, index) in objectPath"> / <u style="cursor:pointer" @click="objectPath=objectPath.slice(index)">{{ item }}</u></span>-->
                       <!-- </span>
                    </div>-->
                    <div style="font-family:'EB Garamond', serif; text-align: center; font-style: italic; margin-bottom: 8px;">Create new room at your location</div>
                    <div>
                        <div class="room-button-container">
                            <button class="inner-button room-button" @click="createRoom(0)">
                                <img src="@/../static/empty_room.png" />
                            </button>
                            <div class="group-button-label" style="text-align: center;">Empty Room</div>
                        </div>
                        <div class="room-button-container">
                            <button class="inner-button room-button" @click="createRoom(2)">
                                <img src="@/../static/watercooler_room.png" />
                            </button>
                            <div class="group-button-label" style="text-align: center;">Watercooler Lounge</div>
                        </div>
                        <div class="room-button-container">
                            <button class="inner-button room-button" @click="createRoom(1)">
                                <img src="@/../static/cozy_room.png" />
                            </button>
                            <div class="group-button-label" style="text-align: center;">Cozy Room</div>
                        </div>
                        <div class="room-button-container">
                            <button class="inner-button room-button" @click="createRoom(3)">
                                <img src="@/../static/forest_room.png" />
                            </button>
                            <div class="group-button-label" style="text-align: center;">Green Room</div>
                        </div>
                    </div> 
                </div>
            </div>
            <div>
                <!--<button :class="{'interface-button':true, 'selected': bl_tab=='emoji'}" @click="toggleBottomLeftPanel('emoji')">
                    <img src="@/../static/icons/emoji.svg" />
                </button>-->
                <button :class="{'interface-button':true, 'selected': bl_tab=='object'}" @click="toggleBottomLeftPanel('object')">
                    <img src="@/../static/icons/objects.svg" />
                </button>
                <button :class="{'interface-button':true, 'selected': bl_tab=='message'}" @click="toggleBottomLeftPanel('message')">
                    <img src="@/../static/icons/message.svg" />
                </button>
                <button :class="{'interface-button':true, 'selected': bl_tab=='room'}" @click="toggleBottomLeftPanel('room')">
                    <img src="@/../static/icons/room2.svg" />
                </button>
            </div>
        </div>
        <!--<div class="panel-container">
            <div v-if="tab != undefined" class="panel">
                <div v-if="tab == 'emote'">
                    <button @click="handleClick(':em---1')"><i class="em em---1"></i></button>
                    <button @click="handleClick('😍')">😍</button>
                    <button @click="handleClick('🙌')">🙌</button>
                    <button @click="handleClick('♥️')">♥️</button>
                    <button @click="handleClick('👊')">👊</button>
                    <button @click="handleClick('🤚')">🤚</button>
                    <button @click="handleClick('✌️')">✌️</button>
                </div>
                <div v-if="tab == 'object'">
                    <button @click="createObject('Test')"><img src="./objects/pottedplant.png" /></button>
                    <button @click="createObject('BlueBalloon')"><img src="@/../static/objects/BlueBalloon.png" /></button>
                    <button @click="createObject('OrangeBalloon')"><img src="@/../static/objects/OrangeBalloon.png" /></button>
                    <button @click="createObject('PurpleBalloon')"><img src="@/../static/objects/PurpleBalloon.png" /></button>
                    <button @click="createObject('RedBalloon')"><img src="@/../static/objects/RedBalloon.png" /></button>
                    <button @click="createObject('GroupBalloons')"><img src="@/../static/objects/GroupBalloons.png" /></button>
                    <button @click="createObject('TreasurePile')"><img src="@/../static/objects/TreasurePile.png" /></button>
                    <button @click="createObject('CouchGrey')"><img src="@/../static/objects/CouchGrey.png" /></button>
                    <button @click="createObject('RockingChair')"><img src="@/../static/objects/RockingChair.png" /></button>
                    <button @click="createObject('Carpet')"><img src="@/../static/objects/Carpet.png" /></button>
                    <button @click="createObject('BirthdayCake')"><img src="@/../static/objects/BirthdayCake.png" /></button>
                </div>
            </div>
        </div>
        <div class="tabs">
            <input ref="emoteRadioButton" type="radio" name="interfaceTabs" id="emotePanelToggle" checked />
            <label class="interfaceTab interface-button" for="emotePanelToggle" @click="toggleBottomLeftPanel('emote')">
                <img src="@/../static/icons/emoji.svg" />
            </label>

            <input ref="objectRadioButton" type="radio" name="interfaceTabs" id="objectPanelToggle" />
            <label class="interfaceTab interface-button" for="objectPanelToggle" @click="toggleBottomLeftPanel('object')">
                <img src="@/../static/icons/objects.svg" />
            </label>
        </div>-->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { createObject, emoji_list, getItemByValue, tempRoomData } from "@/utils.js";

import { v1 as uuidv1 } from 'uuid';

import { fetch } from 'whatwg-fetch';

export default {
    name: "Interface",
    computed: {
        ...mapGetters(["isMuted", "getGroupID", "getSelf", "objectMode", "audioDeviceExists"]),
        shareUrl() {
            return window.location.origin + '/?room=' + encodeURIComponent(this.getGroupID).replace(/\%20/g, '+');
        },
        resolvePath() {
            let output = this;
            this.objectPath.forEach(x => output = getItemByValue(output.groups, 'name', x))

            return output;
        },
        objectsAtPath() {
            return this.resolvePath.objects;
        },
        groupsAtPath() {
            return this.resolvePath.groups;
        }
	},
    data() {
        return {
            bl_tab: null,
            tr_tab: null,
            message: '',
            
            // What and whether to show the 'Link copied!' in share menu
            showCopiedMessage: false,
            copiedMessage: '',

            groups: [],
            objects: [],

            emotes: emoji_list,

            objectPath: []
            /*temp: [
                {type: 'Test', thumbnail: './objects/pottedplant.png'}
            ],*/
        };
    },
    methods: {
        copyURL() {
            // https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
            var copyTextarea = document.getElementById('shareURL');
            copyTextarea.focus();
            copyTextarea.select();
            
            let successMessage = "copied to clipboard";
            let failMessage = "copy link to share";

            this.showCopiedMessage = true;

            try {
                var successful = document.execCommand('copy');

                if (successful) {
                    this.copiedMessage = successMessage;
                } else {
                    this.copiedMessage = failMessage;
                }
            } catch (err) {
                this.copiedMessage = failMessage;
            }        
        },
        toggleBottomLeftPanel(name) {
            if(name === this.bl_tab) {
                this.bl_tab = null;
            } else {
                this.bl_tab = name;
            }

            if(this.bl_tab == 'room') {
                this.$store.dispatch('updateObjectMode', 2);
            } else {
                this.$store.dispatch('updateObjectMode', 0);
            }
        },

        toggleTopRightPanel(name) {
            if(name === this.tr_tab) {
                this.tr_tab = null;
                this.showCopiedMessage = false;
                this.copiedMessage = '';
            } else {
                this.tr_tab = name;
            }
        },

        createObject(object) {
            //this.$store.dispatch('createObject', createObject({ type, x: this.getSelf.x, y: this.getSelf.y }));
            this.$store.dispatch('createObject', createObject(Object.assign({x: this.getSelf.x, y: this.getSelf.y-100}, object)));
        },

        createRoom(number) {
            let data = tempRoomData[number];

            let rooms = data.rooms.map(room => {
                room = Object.assign({}, room, {
                    'id': uuidv1(),
                    'x': room['x'] + this.getSelf.x,
                    'y': room['y'] + this.getSelf.y
                });

                console.log(room);

                this.$store.dispatch('createRoom', room);

                return room
            })

            let objects = data.objects.map(object => {
                object = Object.assign({}, object, {
                    'id': uuidv1(),
                    'in': rooms[object['in']].id
                });

                console.log(object)

                this.$store.dispatch('createObject', object);

                return object
            })
        },

        /*handleClick(emoji) {
            var store = this.$store
            store.dispatch('updateEmote', emoji);  
            
            window.setTimeout(function (emoji) {
                store.dispatch('updateEmote', '');
            }, 3000)
        },*/
        toggleMuted() {
            this.$store.dispatch('updateMuted', !this.isMuted)
        },
        sendMessage() {
            let store = this.$store;
            store.dispatch('sendChat', this.message);

            this.message = '';
        },
        /*sendEmoji(emoji_name) {
            let store = this.$store;
            store.dispatch('updateEmote', `:${emoji_name}:`);
        },*/
        appendPath(name) {
            this.objectPath.push(name)
        },

        keyUp(e) {
            //console.log(e.key);
            if(e.key == 't') { // t
                e.preventDefault();
                this.getSelf.focusText = true
                this.createObject({
                    component: 'Text',
                })
            }
        },

        stopPropagation(e) {
            e.stopPropagation();
        }
    },
    mounted() {
        window.addEventListener('keyup', this.keyUp);

        //self.addEventListener('mousedown', this.handleEmote)
        let _this = this;

        let url = 'https://assets.cozyroom.xyz/objects/'
        fetch(url + 'newcollection.json').then(function(response) {
            response.json().then(function(json) {
                // console.log('JSON', json);
                let urlparams = ['svg', 'image', 'webm', 'icon', 'vue']
                json.objects.forEach(object => {
                    urlparams.forEach(key => {
                        if(key in object) {
                            object[key] = url + object[key]
                        }
                    }) 
                    /*if('svg' in object) {
                        object.svg = url + object.svg;
                    }
                    if('image' in object) {
                        object.image = url + object.image;
                    }*/
                    _this.objects.push(object)
                });
                (json.groups || []).forEach(group => {
                    // console.log(group);
                    group.objects.forEach(object => {
                        urlparams.forEach(key => {
                            if(key in object) {
                                object[key] = url + object[key]
                            }
                        }) 
                    })
                    // console.log(group);
                    _this.groups.push(group);
                })
            })
        })
    }
};
</script>

<style>
    #interface {
        font-family: "Roboto Condensed", sans-serif;
        user-select: none;
    }
    #top-left-controls {
        position: absolute;
        top: 20px;
        left: 20px;
        z-index: 5;
    }

    #top-right-controls {
        position: absolute;
        top: 20px;
        right: 20px;
        max-width: calc(100% - 40px);
        text-align: right;
    }
    #top-right-controls .panel {
        /*border: 4px solid #EFD9B3;*/
        text-align: left;
    }

    #bottom-left-controls {
        position: absolute;
        bottom: 0; left: 0;
        padding: 20px;
        box-sizing: border-box;
        width: 400px;
        max-width: 100%;
    }

    #top-status {
        position: fixed;
        top: 40px;
        left: 0px;
        width: 100%;
        pointer-events: none;
        text-align: center;
    }
    #top-status > div {
        margin: auto;
        padding: 3px 15px;
        background: #EFD9B3;
        border-radius: 5px;
        display: inline-block;
        opacity: 0.5;
        transition: .2s all ease-out;
    }


    .tabs {
        position: absolute;
        /*top: 0; left: 0; width: 100%; height: 100%;*/
        left: 20px; bottom: 20px;
    }

    /*#interface button {
        outline: none;
        border: none;
        background: none;
        cursor: pointer;
    }*/

    .object-panel-header {
        padding: 10px 5px 7px 5px;
        width: 320px;
        max-width: calc(100% - 50px);
        position: fixed;
        background-color: rgba(239, 217, 179, 0.8);
        margin-top: -10px;
    }

    .object-panel-header+div {
        margin-top: 35px;
    }



    .tabs .panel {
        height: 200px;
    }

    /*.tabs .interfaceTab {
        display: inline-block;
        padding: 15px 15px 10px 15px;
        cursor: pointer;

        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;

        border: 1px solid transparent;
    }
    .tabs .interfaceTab svg {
        width: 35px;
        height: 35px;
    }*/

    .tabs > input[type="radio"] {
        display: none;
    }
    /*.tabs > input[type="radio"]:checked + label.interfaceTab {
        background: #FFFFFF;
        border: 1px solid #E0D3BF;
        border-top: none;
    }*/

    .interface-button {
        /* remove button styling*/
        border: 4px solid #FFF5E5;
        outline: none;
        padding: 0;
        -webkit-appearance: none;
        -moz-appearance: none;

        /* styles*/
        display: inline-block; 
        position: relative;
        width: 62px;
        height: 62px;
        background-color: #EFD9B3;
        border-radius: 12px;
        overflow: none;

        cursor: pointer;

        transition: all .1s ease-out;

        margin-right: 6px;
    }
    /*.interface-button:focus {
        border: 1px solid rgb(146, 93, 0);
    }*/
    .interface-button:last-child {
        margin-right: 0px;
    }
    .interface-button:hover {
        background-color: rgb(255, 162, 0);
        background-color: #F6B038;
        background-color: #FEDD8A;
    }
    .interface-button.selected {
        background-color: #EE45A0;
        background-color: #F6B038;
    }
    .interface-button.error {
        background-color: #e05a5a;
    }
    .interface-button img {
        width: 100%;
        height: 100%;
    }


    .inner-button {
        /* remove button styling*/
        background: none;
        border: none;
        outline: none;
        padding: 0;
        -webkit-appearance: none;
        -moz-appearance: none;
        cursor: pointer;
    }

    .object-button, .emoji-button, .room-button {
        width: 59px;
        height: 59px;
        box-sizing: border-box;
        padding: 1px;
        border: 2px solid transparent;
        border-radius:8px;
        margin-right: 5px;
    }
    .room-button {
        width: 140px;
        height: 90px;
        position: relative;
        overflow: hidden;
        background: #FFF5E5;
        border-radius: 5px;
        filter: saturate(0);
        opacity: 0.5;
        border: 2px solid transparent;

        transition: all .1s ease-out;
    }
    .room-button-container {
        width: 140px;
        margin: 6px 9px 8px 9px;
        display: inline-block;
    }
    .room-button:hover {
        filter: saturate(1);
        border-color:rgb(255, 162, 0);
        opacity: 1;
    }
    .room-button img {
        max-width: 100%;
        max-height: 100%;
        display: block;
        margin: auto;
    }
    .emoji-button {
        width: 40px;
        height: 40px;
    }
    .group-button {
        background-color: rgba(0, 0, 0, 0.1);
    }
    .group-button-group {
        width: 59px;
        display: inline-block;
        margin-right: 5px;
        vertical-align: top;
        margin-bottom: 10px;
    }
    .group-button-label {
        text-align: center;
        font-size: 13px;
        margin-top: 3px;
        font-size: 12px;
    }
    .object-button:hover, .emoji-button:hover {
        background-color: #FEDD8A;
        border: 2px solid #FFF5E5;
    }
    .object-button:active,  .emoji-button:active{
        background-color: #F6B038;
    }
    .object-button img {
        width: 50px;
        height: 50px;
    }
    .emoji-button img {
        width: 30px;
        height: 30px;
    }


    .panel-container {
        position: absolute;
        max-width: 100%;
        left: 0px;
        bottom: 85px;
        box-sizing: border-box;
        padding: 0px 20px;
    }
    .panel {
        position: relative;
        width: 400px;
        max-width: 100%;
        background: #EFD9B3;
        /*border-radius: 10px;
        border-bottom-left-radius: 0px;
        /*border-top-left-radius: 10px;
        border-top-right-radius: 10px;*/
        border-radius: 16px;
        box-sizing: border-box;
        max-height: 200px;
        margin: 6px 0px;
        overflow: hidden;
        border: 6px solid #FFF5E5;
    }
    .object-panel.panel {
        height: 300px;
        padding: 10px;
        overflow-y: auto;
    }
    .room-panel.panel {
        padding: 10px;
        overflow-y: auto;
    }
    .input-container-share {
		display: flex;
		flex-direction: row;
    }
    .input-container-share .input-container {
        /*width: 100%;*/
        flex: 1;
        border: none;
        border-radius: 0;
        /*border-bottom-left-radius: 0;
        border-top-left-radius: 0;
        border: none;
        border-radius: 0;*/
    }
    .input-container-share {
        border: 1px solid #E0D3BF;
        border-radius: 10px;
        overflow: hidden;
    }
    .copy-panel.panel {
        display: flex;
        flex-direction: column;
    }
    .copy-button {
        flex: 0 0 1;
        display: flex; 
        width: 54px; 
        background-color: white; 
        cursor: pointer;

        transition: all .1s ease-out;
    }
    .copy-hover:hover {
        background-color: #f0f0f0;
    }
    .copy-icon-container {
        display: flex;
        align-items: center;
        /* padding-right: 5px; */
        width: 100%;
    }
    .copy-button-icon {
        padding: 7px; 
        width: 35px; 
        height: 35px;
        margin-left: auto;
        margin-right: auto;
    }
    .copy-message {
        margin-left: auto; 
        margin-right: auto; 
        padding: 5px;
    }
    .copy-message-link {
        display: flex; 
        flex-grow: 1;
        font-family: inherit;
        font-size: 18px;
        padding-right: 10px;
        padding-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .panel::-webkit-scrollbar{
        width: 8px;  /* Remove scrollbar space */
        background: transparent;  /* Optional: just make scrollbar invisible */
    }
    .panel::-webkit-scrollbar-thumb {
        background: #F6B038;
        background-clip: padding-box;
        border: 8px solid rgba(0, 0, 0, 0);
        border-right-width: 5px;
        border-left: none;
    }

    /*#emotePanel {
        padding: 5px 20px; left: 0; bottom: 50px; background-color: #F9F9F9; position: absolute;
        border: 1px solid #999999;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }

    #emotePanel 
    #emotePanel button:hover {
        background: #EEEEEE;
    }*/
</style>
